import React, { useEffect, useContext, useState } from "react";
import { StoreContext } from "../../context/StoreContext";
import { Certificates } from "./Certificates";
import distance from "./distance";

const SearchResult = ({ ...props }) => {
  const { state, actions } = useContext(StoreContext);
  const [keywords, setKeywords] = useState({
    popupOpen: false,
    specialismes: [],
    kwaliteitsregelingen: [],
    readyForPost: false,
    searchSubmitted: false,
    IDForKwaliteitsregeling: "",
    IDForSpecialismes: "",
    searchString: "",
    currentCertificates: [],
    landingspage: false
  });

  useEffect(() => {
    
  }, []);
/*
  if (state.results.filterd && state.results.filterd.length > 0) {
    return (
      <section className="search-results">
        {!keywords.landingspage && (
          <div className="search-results-header">
            <div className="total-results">
              <span>
                <strong>{state.results.filterd.length}</strong>
                {state.results.filterd.length > 1 ? " resultaten" : " resultaat"}
              </span>
            </div>
            {state.results.filterd.length > 1 && (
              <div className="sort-by">
                <span>Sorteren op:</span>
                <select onChange={(e) => sortResults(e)}>
                  <option data-sort="relevant">Relevantie</option>
                  {state.results.latLong && state.results.latLong[0] && (
                    <option data-sort="distance">Afstand</option>
                  )}
                  <option data-sort="rating">Waardering</option>
                  <option data-sort="name">Naam</option>
                </select>
              </div>
            )}
          </div>
        )}
        {state.results.filterd.map((result, index) => (
          <div key={`${index}result.Name`} className="result">
            <div className="add-to-mail">
              <a href="#" data-remove-if-empty="ignore"></a>
            </div>
            <div className="company-detail">
              <div className="details">
                <h3>{result.Name}</h3>
                {result.AltName && result.AltName.length > 0 && (
                  <>
                  <span className="alternative-names">(
                    {result.AltName}
                    )</span>
                  </>
                )}
                  
                {checkWebsite(result).length > 0 && (
                  <div className="website">
                    <a
                      href={checkWebsite(result)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {result.Site || result.url_1}
                    </a>
                  </div>
                )}
                {result.Mail.length > 0 && (
                  <div className="mail">
                    <a
                      href={`mailto:${result.Mail}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {result.Mail}
                    </a>
                  </div>
                )}
                {result.Phone.length > 0 && (
                  <div className="telephone">
                    <a
                      href={`tel:${result.Phone}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {result.Phone}
                    </a>
                  </div>
                )}
                {result.Loc.length > 0 && (
                  <div className="address">
                    <a
                      href={`https://www.google.nl/maps/place/${result.Loc}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {result.Loc}
                    </a>
                  </div>
                )}
                {result.Rate !== null && (
                  <div className="mobile-rating">
                    {result.Rate !== null && result.RateUrl !== null && result.RateUrl.length > 0 && result.Rate.length > 0 && (
                        <a
                          href={result.RateUrl}
                          target="_blank"
                          rel="noreferrer"
                      >
                        {result.Rate} via Klanten vertellen
                        </a>
                    )}
                  </div>
                )}
                {result.RateUrl !== null && (result.Rate === null || result.Rate === "") && (
                  <div className="mobile-rating">
                          <a
                            href={result.RateUrl}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Beoordeel zelf
                          </a>
                    </div>
                    )}
                
              </div>

              <div className="certificates" onClick={(e) => togglePopup(e, getCertificates(result.Kwaliteitreg))}>
                <h4>Certificering</h4>
                <Certificates
                  certificates={getCertificates(result.Kwaliteitreg)}
                />
              </div>
            </div>
            <div className="rating">
                  <div className="number">
                    {result.Rate === null ? "-" : result.Rate.length > 0 ? result.Rate : "-"}
                  </div>
                  <div className="number-detail">
                    {result.Rate !== null && result.RateUrl !== null && result.RateUrl.length > 0 && result.Rate.length > 0 && (
                      <strong>
                        <a
                          href={result.RateUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          via Klanten vertellen
                        </a>
                      </strong>
                    )}
                    {result.RateUrl !== null && (result.Rate === null || result.Rate === "") && (
                        <strong>
                          <a
                            href={result.RateUrl}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Beoordeel zelf
                          </a>
                        </strong>
                    )}
                  </div>
            </div>
            <div className="mobile-btn-more-info" onClick={(e)=> toggleMoreInfo(e)}>
              <span>Meer informatie</span>
            </div>
          </div>
        ))}
        <div className={popupOpen ? "show popup-info" : "hide popup-info"}>
          <div
            className="close"
            data-remove-if-empty="ignore"
            onClick={(e) => togglePopup(e, [])}
          ></div>
          <h3>Certificaten en regelingen</h3>
          <p>
            Certificaten en regelingen zijn een teken van bewezen vakmanschap.
            Heeft dit bedrijf de beste papieren om uw opdracht uit te voeren?
          </p>
          <ul>
            {keywords.currentCertificates.map((certificate, index) => 
              <li key={certificate, index}>
                <img
                  src={certificate.Logo}
                  title={certificate.Name}
                  width="32"
                />
                <span className="certificate-name">
                  {certificate.Name}
                </span>
              </li>
            )}
          </ul>
        </div>
        <a
        className="btn"
        onClick={activateSearch}
      >
        Bekijk alle vakmensen
      </a>
      </section>
    );
  } else if (state.results.filterd && state.results.filterd.length === 0) {
    return (
      <section className="search-results">
        <div className="nothing-found">Geen resultaten gevonden</div>
      </section>
    );
  } else {
    return (
      <section className="search-results">
        <div className="loading">Zoekresultaten worden geladen</div>
      </section>
    );
  }
  /*
  return (
    <section className="search-results">
      
      {state.results.filterd && state.results.filterd.map((result, index) =>
      <div key={index} className="result">
        <div className="add-to-mail">
          <a href="#">+</a>
        </div>
        <div className="company-detail">
          <div className="details">
            <h3>{result.Name}</h3>
            <div className="website">{result.Site}</div>
            <div className="mail">{result.Mail}</div>
            <div className="telephone">{result.Phone}</div>
            <div className="address">{result.Loc}</div>
          </div>
          <div className="certificates">
            <h4>Certificering</h4>
          </div>
        </div>
        <div className="rating">
          <div className="number">{result.Rate}</div>
          <div className="number-detail">
        </div>
        </div>
        </div>
      )}
    </section>
  );*/
};

export { SearchResult };
